import { ListResult } from 'common/api/v1/types'

export function listResult<T>(items: T[]): ListResult<T> {
    return { items, total: items.length }
}
